import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://api.ggmfapp.com',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor: injeta o token JWT em todas as requisições
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ggmf_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor: tratamento global de erros de autenticação
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expirado ou inválido → limpar sessão
      localStorage.removeItem('ggmf_token');
      localStorage.removeItem('ggmf_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
